import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import LoginComponent from "../components/LoginComponent";
import SignupComponent from "../components/RegisterComponent";
import ForgotPasswordComponent from "../components/ForgotPasswordComponent";
import ResetPasswordComponent from "../components/ResetPasswordComponent";
import ConfirmUserComponent from "../components/ConfirmUserComponent";
import { GoogleOAuthProvider } from "@react-oauth/google";

const AuthRoutes = () => {

    return (
        <GoogleOAuthProvider
            clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}>
            <Routes>
                <Route index element={<LoginComponent />} />
                <Route path="/login" element={<LoginComponent />} />
                <Route path="/register" element={<SignupComponent />} />
                <Route path="/forgot-password" element={<ForgotPasswordComponent />} />
                <Route path="/reset-password" element={<ResetPasswordComponent />} />
                <Route path="/confirm-email" element={<ConfirmUserComponent />} />
            </Routes>
        </GoogleOAuthProvider>

    );
};

export default AuthRoutes;